<template>
  <v-container fluid style="margin-top:1em;">
    <div class="enqForm-header">
      <img alt="image-01" class="form-logoImg" src="../../../../public/img/image_01.png">
      <div class="enquiryTitile-Dsite">Create Enquiry Form</div>
      <div class="childerImg-wrap">
        <img alt="image-02" class="form-childrenImg" src="../../../../public/img/image_02.png">
      </div>

    </div>
    <MaterialCard inline icon="mdi-mail">
      <div class="enquiryTitile-Msite">Create Enquiry Form</div>
      <v-card-actions> </v-card-actions>
      <form name="updateEnquiry" @submit.prevent="saveEnquiry">
        <template>
          <v-card-component style="justify-center:auto">
            <v-row>
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">Select Center</span>
                <v-text-field type="text" placeholder="Enter Center" class="my-0 py-1" single-line v-model="center"
                  readonly disabled>
                </v-text-field>
              </v-col>
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">Academic Year</span>
                <span class="error--text ml-1">*</span>
                <v-autocomplete required v-model="academicYearID" key="id" class="my-0 py-1" single-line
                  placeholder="---Select---" :items="academicYears" item-text="academicYear" item-value="id">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">Child's Age</span>
                <span class="error--text ml-1">*</span>
                <v-autocomplete required v-model="selectedAge" :items="childsAgeList" key="id" single-line
                  placeholder="-Select Age-" class="my-0 py-1" item-text="childAge" item-value="childAge"
                  @change="getProgramList(selectedAge)"></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">Program</span>
                <span class="error--text ml-1">*</span>
                <v-autocomplete required v-model="selectedProgram" :items="programList" key="id" single-line
                  placeholder="-Select Program-" class="my-0 py-1" item-text="name" item-value="category"
                  @change="getClassList(selectedProgram)"></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">Opting Class</span>
                <span class="error--text ml-1">*</span>
                <v-autocomplete v-model="parentdata.classID" key="id" class="my-0 py-1" single-line
                  placeholder="---Select Class---" :items="classes" item-text="name" item-value="id" required>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium text-capitalize">Parent/Guardian's Name</span><span
                  class="error--text ml-1">*</span>
                <v-text-field type="text" placeholder="Enter Name" class="my-0 py-1" single-line v-model="fatherName"
                  required v-on:keypress="isLetter($event)">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium text-capitalize">
                  Email.<span class="error--text ml-1">*</span>
                </span>
                <v-text-field placeholder="Enter Email Address" class="my-0 py-1" type="email" v-model="fatherEmailID"
                  required>
                </v-text-field>
              </v-col>
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium text-capitalize">Mobile No.<span
                    class="error--text ml-1">*</span></span>
                <v-text-field placeholder="Enter Mobile Number" id='txtMobileNumber' class="my-0 py-1" maxlength="10"
                  pattern="^([0|+[0-9]{1,5})?([6-9][0-9]{9})$" inputmode="numeric"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  type="number" v-model="fatherMobile" required v-on:keypress="isNumber($event)">
                </v-text-field><span id="lblError" class="error"></span>
              </v-col>
              <!-- <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">Source 1 </span>
                <v-text-field type="text" placeholder="---" v-model.trim="source1" class="my-0 py-1" readonly single-line
                  disabled>
                </v-text-field>
              </v-col> -->
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium"> How did you learn about Firstcry Intellitots Preschool?
                </span><span class="error--text ml-1">*</span>
                <v-autocomplete v-model="parentdata.sourceID" key="id" class="my-0 py-1" multiple single-line clearable
                  placeholder="---Select---" :items="sourceStages" item-text="name" item-value="id">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">Did you come across a Google advertisement for Firstcry
                  Intellitots Preschool?</span><span class="error--text ml-1">*</span>
                <v-radio-group v-model="isGoogleAdv" required mandatory row>
                  <v-radio label="Yes" name="match" value="Yes" class="mr-7">
                  </v-radio>
                  <v-radio label="No" name="match" value="No" class="mr-7">
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">Child's Name</span>
                <span class="error--text ml-1">*</span>
                <v-text-field type="text" placeholder="Student First Name" v-model="parentdata.studentFirstName"
                  class="my-0 py-1" single-line v-on:keypress="isLetter($event)" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">PIN Code </span><span class="error--text ml-1">*</span>
                <v-text-field placeholder="Pincode" type="number" onKeyPress="if(this.value.length==6) return false;"
                  v-model="pincode" class="my-0 py-1" single-line required @blur="getPincodeData()"
                  :error="isInvalidPincode" :error-messages="invalidPincodeErrorMsg">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <!-- <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium"> Child's DOB </span><span class="error--text ml-1">*</span>
                <custom-date-picker v-model="dateOfBirth" :maxToDate="maxToDate" mandatory />
              </v-col> -->
              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">Address </span><span class="error--text ml-1">*</span>
                <!--  -->
                <v-text-field type="text" placeholder="Address" v-model.trim="address" class="my-0 py-1" single-line
                  required>
                </v-text-field>
              </v-col>

              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">City</span><span class="error--text ml-1">*</span>
                <v-text-field disabled type="text" placeholder="City" v-model.trim="parentdata.city" class="my-0 py-1"
                  single-line v-on:keypress="isLetter($event)" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" lg="4" sm="6"><span class="body-2 font-weight-medium">State</span><span
                  class="error--text ml-1">*</span>
                <v-text-field disabled type="text" placeholder="State" v-model.trim="parentdata.state" class="my-0 py-1"
                  single-line v-on:keypress="isLetter($event)" required>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <!-- <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">PIN Code </span><span class="error--text ml-1">*</span>
                <v-text-field placeholder="Pincode" type="number" onKeyPress="if(this.value.length==6) return false;"
                  v-model="pincode" class="my-0 py-1" single-line required>
                </v-text-field>
              </v-col> -->

              <v-col cols="12" lg="4" sm="6">
                <span class="body-2 font-weight-medium">Country</span><span class="error--text ml-1">*</span>
                <v-text-field placeholder="Country" disabled type="text" v-model="parentdata.countryName"
                  class="my-0 py-1" single-line v-on:keypress="isLetter($event)" required>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-component>
        </template>
        <v-card-actions class="d-flex justify-end">
          <v-btn bottom :disabled="hasClicked" right elevation="1" color="primary" type="submit">
            <v-icon left> mdi-content-save </v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </form>
    </MaterialCard>

    <v-dialog content-class="thanksPopup-wrapper" v-model="thankYouDialog" persistent>
      <v-card>
        <span class="closeBtn" @click="thankYouDialogClose()">&times;</span>
        <div class="thankyou-dialog">
          <v-card-title>
            <div class="lottie-img">
              <dotlottie-player src="https://stagecdn.brainbees.com/education/ops-app/stage/images/green-tick.lottie"
                autoplay loop></dotlottie-player>
            </div>
            <span class="thanksTitle">Thank you for sharing your details! We're delighted you visited Firstcry
              Intellitots.</span>
            <div class="counsellorTouch">You've unlocked your rewards, and they will be sent to you shortly via
              WhatsApp! 🎁
            </div>
          </v-card-title>
        </div>
      </v-card>
    </v-dialog>
    <!-- msite download thankyou pop up -->
    <div v-if="thankFirst" class="thanks-popup">
      <div class="thanks-content">
        <div class="lottie-img">
          <dotlottie-player src="https://cdn.fcglcdn.com/education/totsweb/live/fcintelli/orangetick.lottie" autoplay
            loop></dotlottie-player>
        </div>
        <p>Thank You! Our Counsellor will connect with you shortly.</p>
      </div>
    </div>
    <div v-if="thankyouPopUpMsite" class="overlay">
      <div class="thankyou-msite" :style="{ background: slides[currentSlideIndex]?.background }">
        <div class="inner-contents">
          <div class="main-text">
            <h2>FirstCry IntelliEducation App- Where Education Meets Smart Technology!</h2>
          </div>
          <div v-if="slides.length" ref="slider" class="my-slider">
            <div v-for="(slide, i) in slides" :key="i">
              <img :src="slide.image" alt="" class="slide-image" />
              <h3 class="slide-title">{{ slide.title }}</h3>
              <p class="slide-subtitle">{{ slide.subtitle }}</p>
            </div>
          </div>

          <div class="card-text">
            <p>Download Our App</p>
          </div>
          <div class="download-button">
            <a
              href="https://play.google.com/store/apps/details?id=com.firstcryintellitots.preschoolparentapp&hl=en-IN&pli=1"><img
                width="100%" target="_blank"
                src="https://cdn.fcglcdn.com/education/totsweb/live/fcintelli/google-play-store.jpg"
                alt="Android Logo" /></a>
            <a href="https://apps.apple.com/in/app/firstcry-intelli-education/id1562465674" target="_blank"><img
                width="100%" src="https://cdn.fcglcdn.com/education/totsweb/live/fcintelli/app-Store.jpg"
                alt="Google Logo" /></a>
          </div>
        </div>
      </div>
    </div>
    <!-- end of download thankyou pop up -->
    <!-- <v-dialog width="600" v-model="invalidPincode" persistent>
      <v-card>
        <v-toolbar elevation="0" dark color="accent">
          <v-toolbar-title>Invalid Pincode</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="invalidpincodeDialogClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <v-card-title>
                No Franchisee and Pincode Mapping exists.
              </v-card-title>
            </v-col>
          </v-row>
        </v-card-text>
     </v-card>
    </v-dialog> -->
    <loading-icon :value="isLoading" />
  </v-container>

</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import Utils from '@/utils'
import constants from '@/utils/constants'
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { tns } from 'tiny-slider/src/tiny-slider'
import 'tiny-slider/src/tiny-slider.scss'
// import CustomDatePicker from '@/components/template/CustomDatePicker'

export default {
  name: 'newEnquiryForm',
  props: ['fid', 'mid'],
  components: {
    MaterialCard,
    VCardComponent
    // CustomDatePicker
  },

  data: function () {
    return {
      thankYouDialog: false,
      thankFirst: false,
      thankyouPopUpMsite: false,
      isMobileDevice: false,
      invalidPincode: false,
      parentdata: {
        initial: 'Q',
        formType: 'QR',
        academicYearID: null,
        studentFirstName: '',
        studentMiddleName: '',
        studentLastName: '',
        // dateOfBirth: null,
        dateOfEnquiry: moment().format('YYYY-MM-DD HH:mm:ss'),
        fatherName: '',
        fatherMobile: '',
        pincode: null,
        city: '',
        classID: null,
        address: '',
        countryName: 'India',
        state: '',
        source1: '',
        source2: '',
        sourceName: '',
        fatherEmailID: '',
        sourceID: []
      },
      isLoading: false,
      enquiry: {},
      academicYears: [],
      data: [],
      assignedToUser: null,
      hasClicked: false,
      loader: true,
      canEdit: false,
      formData: {},
      isSendEmail: false,
      message: '',
      formType: 'enquiry',
      Admin: false,
      isEnquiry: false,
      sectionData: [],
      classes: [],
      selectedLocation: null,
      fatherDetails: '',
      pincode: null,
      fatherName: '',
      fatherMobile: null,
      classID: null,
      center: null,
      maxToDate: moment().format('YYYY-MM-DD'),
      selectedZones: ['North', 'East', 'WEST', 'South'],
      selectedState: [],
      selectedCity: [],
      selectedCenter: [],
      source1: 'Walk-in',
      source2: [],
      isGoogleAdv: 'No',
      academicYearID: null,
      sortedCenters: [],
      // dateOfBirth: '',
      redirectUrl: 'https://www.firstcryintellitots.com/',
      // thanksURL: constants.enqThankYouPage,
      address: '',
      city: '',
      sourceStages: [],
      fatherEmailID: '',
      programList: [],
      selectedProgram: '',
      childsAgeList: [],
      selectedAge: '',
      isInvalidPincode: false,
      invalidPincodeErrorMsg: '',

      currentSlideIndex: 0,
      slides: [
        {
          image: 'https://cdn.fcglcdn.com/education/totsweb/live/fcintelli/portal-pop-first.png',
          title: 'Personalized Updates',
          subtitle: 'Stay in the loop with real-time updates on classwork, events, homework & more.',
          background: 'transparent linear-gradient(180deg, #FFF4E0 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box'
        },
        {
          image: 'https://cdn.fcglcdn.com/education/totsweb/live/fcintelli/portal-pop-second.png',
          title: 'Smart Learning Tools',
          subtitle: 'Access expert-curated free worksheets & fun engaging activities.',
          background: 'transparent linear-gradient(180deg, #FFE7EF 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box'
        },
        {
          image: 'https://cdn.fcglcdn.com/education/totsweb/live/fcintelli/portal-pop-third.png',
          title: 'Unlock Exclusive Rewards',
          subtitle: 'Enjoy special discounts & exciting offers on educational books & toys with intelliRewards.',
          background: 'transparent linear-gradient(180deg, #EBE6FF 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box'
        },
        {
          image: 'https://cdn.fcglcdn.com/education/totsweb/live/fcintelli/portal-pop-fourth.png',
          title: 'Ultimate Guide for Parents',
          subtitle: 'Explore expert articles, creative activities & helpful resources to support learning at home',
          background: 'transparent linear-gradient(180deg, #E0F1FF 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box'
        }
      ],
      slider: null
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted () {
    this.loadScript('https://cdn.fcglcdn.com/brainbees/js/m1/json/lottiejson/dotlottie-player.js')
    // this.$nextTick(() => {
    //   this.slider = tns({
    //     container: this.$refs.slider,
    //     items: 1,
    //     slideBy: 'page',
    //     autoplay: false,
    //     controls: true,
    //     nav: false,
    //     autoplayButtonOutput: false
    //   })
    // })
  },
  watch: {
    selectedProgram: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal === constants.ENQUIRY_TOTS_READINESS_PROGRAM.name) {
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''
      } else {
        const currentAcademicYear = Utils.getCurrentYearAcademicRange()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''
      }
    },
    thankyouPopUpMsite (val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.initSlider()
            this.$nextTick(() => {
              const nav = this.$el.querySelector('.tns-nav')
              const cardText = this.$el.querySelector('.card-text')
              if (nav && cardText) {
                cardText.parentNode.insertBefore(nav, cardText)
              }
            })
          }, 100)
        })
      }
    }
  },
  async created () {
    await this.customCreate()
    await this.decodeFranchisee()
    await this.getWatsappData()
    await this.getYear()
    await this.getChildAgeList()
    this.Admin = Utils.helper.isSuperAdmin()
    if (this.Admin) {
      this.canEdit = true
    }
    if (this.formType === 'enquiry') {
      this.isEnquiry = true
    }
    this.isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
  },

  methods: {
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/v1/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentYearAcademicRange()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    saveEnquiry: async function () {
      try {
        this.loader = true
        this.hasClicked = true
        this.loader = true
        if (!this.fatherName) {
          return this.$buefy.dialog.alert({
            message: 'father name is required!',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (!this.fatherMobile) {
          return this.$buefy.dialog.alert({
            message: 'Mobile number is required!',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (!this.parentdata.sourceID || this.parentdata.sourceID.length === 0) {
          return this.$buefy.dialog.alert({
            message: 'How did you learn about is required Field!',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }

        this.parentdata.initial = 'Q'
        this.parentdata.formType = 'QR'
        this.parentdata.academicYearID = this.academicYearID
        this.parentdata.refSource = this.source
        this.parentdata.sourceName = 'QR Leads'
        this.parentdata.fatherName = this.fatherName
        this.parentdata.fatherMobile = this.fatherMobile
        this.parentdata.address = this.address
        this.parentdata.pincode = this.pincode
        this.parentdata.fatherEmailID = this.fatherEmailID
        this.parentdata.isGoogleAdv = this.isGoogleAdv
        // this.parentdata.source1 = this.source1
        let data = await http.post(`${constants.API_URL}/api/enquiry`, this.parentdata)
        // window.open(this.thanksURL, '_self')
        let response = data.data
        if (response.enquiryCode) {
          // this.thankYouDialog = true
          this.checkScreenSize()
        } else if (response.message) {
          return this.$dialog.error({
            text: `Contact details already exist. Please try again after 24 hours. 
                   Apologies for the inconvenience.`,
            title: 'Error'
          })
        }
        this.resetAll()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.lock = false
        this.hasClicked = false
        this.loader = false
      }
    },

    getSections: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        if (
          this.formType === 'edit_registration' ||
          this.formType === 'admission'
        ) {
          const { data } = await http.get(
            `${constants.API_URL}/api/students/section/${this.value.classID}`
          )
          this.sectionData = data.studentSections
        }

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry stage data : ', errorMessage)
      }
    },
    customCreate: async function () {
      const allFranchisee = await http.get(
        `${constants.API_URL}/api/franchisee/get/all-active`
      )
      this.selectedCenter = allFranchisee.data

      const { data: questions1 } = await http.get(
        `${constants.API_URL}/api/enquiry-questions`
      )
      this.sourceStages = questions1.filter(
        (obj) => obj.type === 'SOURCE_OF_CONTACT' && obj.isActive
      )
    },
    async decodeFranchisee () {
      try {
        let fid = Number(Buffer.from(this.fid, 'base64'))
        if (_.isNaN(fid)) {
          return null
        }
        this.parentdata.franchiseeID = fid

        this.sortedCenters = _.filter(this.selectedCenter, (obj) => {
          if (obj.id === fid) {
            return obj.companyName
          }
        })
        this.center = this.sortedCenters[0].companyName
        if (_.isNaN(Number(this.mid))) {
          this.fatherMobile = null
        } else {
          this.fatherMobile = this.mid
        }
      } catch (e) {
        this.errMsg('Invalid URL!')
      }
    },
    async getWatsappData () {
      if (this.fatherMobile) {
        const watsappData = await http.get(
          `${constants.API_URL}/api/get-watsapp-enquiry/${this.fatherMobile}`
        )
        if (watsappData.status === 200) {
          // this.dateOfBirth = watsappData.data.dateOfBirth
          this.fatherName = watsappData.data.fatherName
          this.pincode = watsappData.data.pincode
          this.source1 = watsappData.data.utmSource
        }
      }
    },

    async getPincodeData () {
      if (this.pincode.length === 6) {
        try {
          let url = `${constants.API_URL}/api/enquiry/get-city-and-state-by-pincode`
          const result = await http.post(url, { pincode: this.pincode })
          this.$set(this.parentdata, 'city', result.data.city)
          this.$set(this.parentdata, 'state', result.data.state)
          this.isInvalidPincode = false
          this.invalidPincodeErrorMsg = ''
        } catch (e) {
          this.isInvalidPincode = true
          this.invalidPincodeErrorMsg = 'Please enter valid pincode.'
          this.$set(this.parentdata, 'city', '')
          this.$set(this.parentdata, 'state', '')
        }
      } else {
        this.$set(this.parentdata, 'city', '')
        this.$set(this.parentdata, 'state', '')
      }
    },

    isLetter (e) {
      let char = String.fromCharCode(e.keyCode) // Get the character
      if (/^[A-Za-z\s]+$/.test(char)) return true // Match with regex
      else e.preventDefault() // If not match, don't add to input text
    },
    isNumber (e) {
      let char = String.fromCharCode(e.keyCode) // Get the character
      if (/^\d+$/.test(char)) return true // Match with regex for numbers
      else e.preventDefault() // If not a number, prevent adding to input text
    },
    getClassList: async function (value) {
      try {
        let url = `${constants.API_URL}/api/students/class-programs`
        let obj = {
          name: value
        }
        const response = await http.post(url, obj)
        this.classes = response.data
        this.classes.forEach(item => {
          if (item.category === constants.classCategory.BRIDGE_COURSE || item.category === constants.classCategory.parentToddler) {
            item.name = item.type
          } else if (_.isEmpty(item.fbName)) {
            item.name = `${item.name}`
          } else {
            item.name = `${item.name} - ${item.fbName}`
          }
          if (item.category === constants.classCategory.HYBRID) {
            if (item.type === value) {
              this.parentdata.classID = item.id

              const specialClassIDs = [254, 255, 256, 257]// Id for toddler,nursery,pp1,pp2

              const currentMonth = new Date().getMonth()
              if (specialClassIDs.includes(this.parentdata.classID) && (currentMonth === 11)) {
                const currentAcademicYear = Utils.getCurrentYearAcademicRangeForPerticularClass()
                let academicYear = this.academicYears.find(y => {
                  return y.academicYear.trim() === currentAcademicYear.trim()
                })
                this.academicYearID = academicYear ? academicYear.id : ''
              }
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    getProgramList: async function () {
      try {
        this.classes = []
        let url = `${constants.API_URL}/api/students/programs-list`
        let obj = {
          childAge: this.selectedAge
        }
        const result = await http.post(url, obj)
        this.programList = result.data
      } catch (e) {
        console.log(e)
      }
    },
    getChildAgeList: async function () {
      try {
        const responce = await http.get(`${constants.API_URL}/api/students/age-list`)
        this.childsAgeList = responce.data
      } catch (e) {
        console.log(e)
      }
    },
    loadScript (url) {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = url
      script.async = true
      script.onload = () => {
        /* eslint-disable *//* eslint-disable */console.log(...oo_oo(`1191633381_41_28_41_111_4`, ...oo_oo(`4116238867_48_8_48_55_4`, `Script loaded successfully .. !!`)))
      }
      script.onerror = (error) => {
        console.error('Script loading error:', error)
      }
      document.head.appendChild(script)
    },

    thankYouDialogClose: async function () {
      this.thankYouDialog = false
      this.toggleBodyScroll(false); // Enable scrolling
      window.open(this.redirectUrl, '_self')
    },

    invalidpincodeDialogClose: async function () {
      this.invalidPincode = false;
      this.pincode = '';
      this.parentdata.city = '';
      this.parentdata.state = '';
    },
    resetAll: function () {
      this.selectedAge = ''
      this.selectedProgram = ''
      this.parentdata.classID = '';
      this.fatherName = '';
      this.fatherEmailID = '';
      this.fatherMobile = '';
      this.parentdata.studentFirstName = ''
      this.address = ''
      this.pincode = '';
      this.parentdata.sourceID = []
      this.parentdata.city = '';
      this.parentdata.state = '';
    },
    initSlider() {
      const container = this.$refs.slider;
      if (!container || !container.children || container.children.length === 0) {
        console.warn("Slider not ready yet.");
        return;
      }
      const isMobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      const isSmallScreen = window.innerWidth <= 767;
      const isMobileDevice = isMobileUA || isSmallScreen; // Adjusted condition to include both scenarios
      this.slider = tns({
        container,
        items: 1,
        slideBy: 'page',
        autoplay: true,
        autoplayTimeout: 2000, 
        nav: true,
        controls: true,
        mouseDrag: true,
        touch: true, 
        swipeAngle: false, 
        speed: 300, 
        autoplayButtonOutput: false
      });
      if (isMobileDevice) {
        this.slider.events.on('indexChanged', (info) => {
          this.currentSlideIndex = info.displayIndex - 1;
        });
      }
    },
      checkScreenSize() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isMobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent);
        const isSmallScreen = window.innerWidth <= 767;
        const isMobileDevice = isMobileUA && isSmallScreen;
        if (isMobileDevice || window.screen.width <= 767) {
          this.thankFirst = true;
          this.toggleBodyScroll(true); // Disable scrolling
          this.$nextTick(() => {
            setTimeout(() => {
              this.thankFirst = false;
              this.thankyouPopUpMsite = true;
            }, 2000);
          });
        } else {
          this.thankyouPopUpMsite = false;
          this.thankYouDialog = true;
        }
      },
      toggleBodyScroll(disable) {
        if (disable) {
          document.body.classList.add('no-scroll');
        } else {
          document.body.classList.remove('no-scroll');
        }
      }
    }
  }
</script>

<style>
@font-face {
  font-family: 'Nunito-ExtraBold';
  src: url('https://cdn.fcglcdn.com/education/ie-app/live/fonts/Nunito-ExtraBold.woff2') format('woff2');
  font-weight: 800;
  /* Font weight for ExtraBold */
  font-style: normal;
}

@font-face {
  font-family: 'Nunito-SemiBold';
  src: url('https://cdn.fcglcdn.com/education/ie-app/live/fonts/Nunito-SemiBold.woff2') format('woff2');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Nunito-Bold';
  src: url('https://cdn.fcglcdn.com/education/ie-app/live/fonts/Nunito-Bold.woff2') format('woff2');
  font-weight: bold;
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: 'Nunito-SemiBold';
  src: url('https://cdn.fcglcdn.com/education/ie-app/live/fonts/Nunito-SemiBold.woff2') format('woff2');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Nunito-ExtraBold';
  src: url('https://cdn.fcglcdn.com/education/ie-app/live/fonts/Nunito-ExtraBold.woff2') format('woff2');
  font-weight: 800;
  /* Font weight for ExtraBold */
  font-style: normal;
}

span.thanksTitle {
  font-size: 16px;
  font-weight: 24px;
  height: 21px;
  width: 100%;
  color: #212121;
  text-align: center;

  letter-spacing: 0px;
  /* position: absolute; */
  word-break: normal;
  padding-right: 21px;

}

.counsellorTouch {
  font-size: 13px;
  letter-spacing: 0px;
  color: #424242;
  text-align: center;
  width: 100%;
  padding-top: 70px;
  word-break: normal;
  padding-right: 10px;
}

.thankyou-dialog {
  padding-bottom: 40px;
  padding-top: 33px;
}

span.closeBtn {
  opacity: 1;
  float: right;
  font-size: 24px;
  margin-right: 16px;
  margin-top: 16px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 34px;
  font-weight: bold;
  color: #aaa;
}

dotlottie-player {
  height: 57px;
  width: 80px;
  text-align: center;
}

.v-card__title {
  padding-right: 0px;
}

.lottie-img {
  margin: 0 auto;
  padding-bottom: 10px;
}

.thanksPopup-wrapper {
  align-self: flex-end;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  margin: 0;
  max-width: 360px;
}

.enquiryTitile-Dsite {
  display: block;
}

.enquiryTitile-Msite {
  display: none;
}

.invalidpincode-dialog {
  padding: 23px;
}

.text-start.v-card--material__heading.rounded-lg.v-sheet.theme--dark.elevation-2.green.pa-5 {
  display: none;
}

.enqForm-header {
  display: flex;
  justify-content: space-between;
  /* margin-top: 40px; */
  background-color: #FFECF5;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding-left: 32px;
  max-height: 96px;
  position: relative;
  margin-bottom: -28px;
}

.childerImg-wrap {
  margin-top: -24px;
}

img.form-logoImg {
  margin-top: 10px;
  margin-bottom: 16px;
  width: 10%;
  /* max-height: 72px; */
  align-self: center;
}


.enquiryTitile-Dsite {
  line-height: 21px;
  font-size: 24px;
  align-self: center;
}

.enquiryTitile-Msite {
  line-height: 21px;
  font-size: 18px;
  margin-top: 24px;
  margin-left: 3px;
}

img.form-childrenImg {
  min-height: 120px;
}

@media(min-width:768px) {
  .thanksPopup-wrapper {
    align-self: inherit;
    max-width: 360px;
  }


}

@media(max-width: 767px) {
  .enquiryTitile-Dsite {
    display: none;
  }

  .enquiryTitile-Msite {
    display: block;
  }

  img.form-logoImg {
    width: 27%;

  }

  .enqForm-header {
    margin-top: 16px;
    padding-left: 12px;
  }

  .my-slider .slide-image {
    width: 300px;
    height: 250px;
  }

  .slide-title {
    font-family: 'Nunito-ExtraBold';
    text-align: center;
    font-size: 16px;
    line-height: 30px;
    color: #212121;
    margin-top: 28px;
  }

  .slide-subtitle {
    font-family: 'Nunito-SemiBold';
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    color: #424242;
    max-width: 292px;
    margin: 0 auto;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .thanks-popup {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent linear-gradient(180deg, #FFF4E0 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .thankyou-msite {
    background: white;
    border-radius: 0px;
    padding: 40px 0px;
    max-width: 100%;
    width: 100%;
    text-align: center;
    transition: background 0.5s ease;
  }

  .download-button img {
    width: 125px;
    height: 42px;
  }

  #tns1-ow .tns-controls {
    display: none !important;
  }

  .main-text h2 {
    color: #212121;
    font-size: 15px;
    line-height: 22px;
    text-align: centre;
    font-family: 'Nunito-Bold';
  }

  .inner-contents {
    padding: 40px 0px;
  }

  .inner-contents .main-text {
    max-width: 210px;
    margin: 0 auto;
  }

  .card-text p {
    color: #424242;
    font-family: 'Nunito-SemiBold';
    font-size: 14px;
    line-break: 21px;
  }

  .download-button {
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
  }

  .tns-nav {
    display: flex;
    justify-content: center;
    margin: 16px 0;
    gap: 8px;
  }

  .tns-nav button {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #BDBDBD;
    border: none;
    transition: background-color 0.3s;
  }

  .tns-nav button.tns-nav-active {
    background-color: #616161;
  }

  .main-text {
    padding-top: 40px;
  }

  .main-text h2 {
    padding-bottom: 24px;
  }

  .thanks-content {
    text-align: centre;
  }

  .thanks-content {
    max-width: 238px;
    text-align: center;
    margin: 0 auto;
  }

  .thanks-content .lottie-img {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 24px;
  }

  .thanks-content p {
    color: #FF8800;
    font-family: 'Nunito-ExtraBold';
    font-size: 18px;
    line-height: 27px;
  }
  .thanks-content .lottie-img dotlottie-player {
  height: 124px;
  width: 124px;
  text-align: center;
}
.no-scroll {
  overflow: hidden;
  height: 100%;
  position: fixed;
  width: 100%;
}
}
</style>
